import { useCallback } from 'react';

import { useObservability } from 'helpers/observability';

import type { HubSectionId } from './hubSectionOrdering';

/**
 * Returns a click reporter for the given hub dashboard section. Reuses the
 * platform `buttonClickEvent` (matching the existing `account-section-click`
 * convention) with a `dashboard-{section}` target name, so no dashboard-specific
 * Journey event is needed. Flushes immediately because a section click is
 * normally followed by a navigation that can unload the page before a batched
 * event would be sent.
 */
export const useHubSectionTracking = (section: HubSectionId): (() => void) => {
  const { trackJourneyEvent } = useObservability();

  return useCallback(() => {
    trackJourneyEvent(
      'platform',
      'buttonClickEvent',
      { targetName: `dashboard-${section}` },
      { flush: true },
    );
  }, [section, trackJourneyEvent]);
};
